import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const readonlyChecklistOptionStyle = css`
  margin-bottom: ${theme.spacing(0)};
  height: 30px;
  > div {
    opacity: 0.7;
  }
  > label {
    opacity: unset;
  }
`;

export const checklistFieldStyle = css`
  margin-bottom: ${theme.spacing(3)};
`;
